package provider

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.ui.unit.DpSize
import androidx.compose.ui.unit.dp
import kotlinx.browser.window

class DisplayProvider(initial: Resolution) : CommonDisplayProvider() {
    private val mobileVariants = listOf(
        "Android",
        "webOS",
        "iPhone",
        "iPad",
        "iPod",
        "BlackBerry",
        "IEMobile",
        "Opera Mini"
    )

    override val isMobile: Boolean = mobileVariants.any { window.navigator.userAgent.contains(it) }

    override var resolution: Resolution by mutableStateOf(initial)

    override var resolutionDp: DpSize by mutableStateOf(
        DpSize(
            width = (initial.width / initial.dpi).dp,
            height = (initial.height / initial.dpi).dp
        )
    )

    override var isMobileOrSmall by mutableStateOf(isMobile || resolution.width < 1000F)
        private set

    fun onResize(new: Resolution) {
        resolution = new
        isMobileOrSmall = isMobile || resolution.width < 1000F
        resolutionDp = DpSize(
            width = (new.width / new.dpi).dp,
            height = (new.height / new.dpi).dp
        )
    }
}
